<ng-container *ngIf="surveyViewerService.activeSurvey$ | async">
  <div data-testId="phoneForm">
      <mat-form-field data-testId="phone" appearance="outline"
                      [ngClass]="isSmallScreen ? 'info-mobile-container' : 'info-desktop-container'">
          <mat-label>{{question.statements[question.phoneFormControlName].label | translateLabel: activeLang}}</mat-label>
          <input appNoPaste matInput placeholder="xxx-xxx-xxxx"
                 [formControl]="$any(questionFormControl)"
                 (blur)="questionFormControl.setValue($event.target.value.trim())">
          <mat-error>
              {{'Numéro de téléphone invalide.'|transloco}}
          </mat-error>
      </mat-form-field>
  </div>
</ng-container>
